<template>
  <div class="tableEEE" :style="{'padding-top':top}">
<!--    <img src="/static/icon/de_search.png" alt="">-->
    <img v-if="!empty.status" :src="'/static/icon/'+picText" alt="">
    <img v-else :src="'/static/icon/'+picSearch" alt="">
    <p style="line-height: normal">
      {{empty.status?emptySearch:emptyText}}
    </p>
  </div>
</template>

<script>
  // grey_de_normal
  // grey_de_search
  // de_normal
  // de_search
    export default {
        name: "emptyTable",
      props:{
          top:{
            default: ()=>'140px'
          },
        picText:{ //无搜索项目 图片
          default: ()=>'grey_de_normal.png'
        },
        picSearch:{ //有搜索项目 图片
          default: ()=>'grey_de_search.png'
        },
          emptySearch:{ //有搜索项目 文字
            default: ()=>'暂未搜索到相关内容~'
          },
          emptyText:{ //无搜索项目 文字
            default: ()=>'暂无内容~'
          },
        // 是否在搜索接口后面
        empty:{
          type:Object,
          default:()=>{return{
            status:false
          }}
        },
      }
    }
</script>

<style lang="less" scoped>
  .tableEEE{
    padding-bottom: 20px;
    text-align: center;
    img{
      width: 250px;
    }
    p{
      font-size: 14px;
      font-weight: 400;
      color: #333333;
    }
  }

</style>
